import type { FC } from 'react';
import * as Styled from './styled';
import type { ModalTitleProps } from './types';

export * from './types';

export const ModalTitle: FC<ModalTitleProps> = (props) => {
  const { children } = props;

  return <Styled.Title>{children}</Styled.Title>;
};
